import React from 'react';
import { withRouter  } from 'react-router-dom';
import moment from 'moment';
import swal from 'sweetalert';
import { getImageUrl } from '../utils/common';
import ActionMenu from '../components/utils/ActionMenu';
import { useSelector } from 'react-redux';
import { userRoleSelector } from '../selectors';
import { deleteNews } from '../action';
import { useDispatch } from 'react-redux';
import { roleId } from '../constants/app';

function NewsList({ items, history }) {
    const role = useSelector(userRoleSelector);
    const dispatch = useDispatch();

    const renderThead = () => {
        return (
            <thead className="kt-datatable__head">
                <tr className="kt-datatable__row">
                    <th className='kt-datatable__cell news_image'>
                        <span>Картинка</span>
                    </th>
                    <th className='kt-datatable__cell news'>
                        <span>Заголовок</span>
                    </th>
                    <th className="kt-datatable__cell" width="110px">
                        <span>Дата</span>
                    </th>
                    <th className='kt-datatable__cell news'>
                        <span>Краткое описание</span>
                    </th>
                    <th className="kt-datatable__cell text-left" width="auto">
                        <span>Полное описание</span>
                    </th>
                    <th className="kt-datatable__cell" width="80px">
                        <span>Действия</span>
                    </th>
                </tr>
            </thead>
        );
    }

    const onDelete = (id) => {
        swal({
            title: `Удаление новости`,
            text: `Вы действительно хотите удалить новость #${id}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteNews(id));
            }
        });
    }

    const handleDoubleClick = (item) => () => {
        history.push(`/marketing/news/${item.id}`)
    };

    const renderBody = () => {
        return (
            <tbody className="kt-datatable__body">
                {
                   items.length === 0 && (
                        <tr className="kt-datatable__row">
                            <td className="kt-datatable__cell">Новостей пока нет</td>
                        </tr>
                    )
                }
                {
                    items.map(item => {
                        const actions = [
                            { access: [roleId.admin, roleId.chiefMarketingSpecialist, roleId.marketingSpecialist], name: 'Редактирование', icon: 'flaticon2-contract', action: () => history.push(`/marketing/news/${item.id}`) },
                            { access: [roleId.admin, roleId.chiefMarketingSpecialist, roleId.marketingSpecialist], name: 'Удалить', icon: 'flaticon2-trash', action: () => onDelete(item.id) }
                        ].filter(item => !item.access || item.access.includes(role));

                        return (
                        <tr onDoubleClick={handleDoubleClick(item)} key={item.id} className="kt-datatable__row baseline-row">
                            <td className='kt-datatable__cell news_image'>
                                <img width="100%" src={getImageUrl(item.image)} alt="231"/>
                            </td>
                            <td className='kt-datatable__cell news'>
                                {item.title}
                            </td>
                            <td className="kt-datatable__cell" width="110px">
                                {moment(item.created_at).format('DD.MM.YYYY HH:mm')}
                            </td>

                            <td className='kt-datatable__cell news'>
                                {item.description}
                            </td>
                            <td className="kt-datatable__cell" width="auto">
                                {item.text}
                            </td>
                            <td className="kt-datatable__cell" align='right' width="80px">
                                <ActionMenu actions={actions}/>
                            </td>
                        </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    const renderBodyMobile = () => {
        return(
            <tbody className="kt-datatable__body">
                {
                   items.length === 0 && (
                        <tr className="kt-datatable__row">
                            <td className="kt-datatable__cell">Новостей пока нет</td>
                        </tr>
                    )
                }
                {
                    items.map(item => {
                        const actions = [
                            { access: [roleId.admin, roleId.chiefMarketingSpecialist, roleId.marketingSpecialist], name: 'Редактирование', icon: 'flaticon2-contract', action: () => history.push(`/marketing/news/${item.id}`) },
                            { access: [roleId.admin, roleId.chiefMarketingSpecialist, roleId.marketingSpecialist], name: 'Удалить', icon: 'flaticon2-trash', action: () => onDelete(item.id) }
                        ].filter(item => !item.access || item.access.includes(role));

                        return (
                        <tr onDoubleClick={handleDoubleClick(item)} key={item.id} className="kt-datatable__row baseline-row">
                            <div className='mobile_div_flex column padding10px'>
                                <div className='mobile_div_flex'>
                                    <div style={{ width: '50%'}}>
                                        <span style={{ color: '#4f62b5' }}>Заголовок: </span>
                                    </div>
                                    <div style={{ width: '50%'}}>
                                        {item.title}
                                    </div>
                                </div>
                                <div className='mobile_div_flex'>
                                    <div style={{ width: '50%'}}>
                                        <span style={{ color: '#4f62b5' }}>Дата: </span>
                                    </div>
                                    <div style={{ width: '50%'}}>
                                        {moment(item.created_at).format('DD.MM.YYYY HH:mm')}
                                    </div>
                                </div>
                                <div className='mobile_div_flex'>
                                    <div style={{ width: '50%'}}>
                                        <span style={{ color: '#4f62b5' }}>Краткое описание: </span>
                                    </div>
                                    <div className='mobile_div_flex wrap' style={{ width: '50%'}}>
                                        {item.description}
                                    </div>
                                </div>
                                <div className='mobile_div_flex'>
                                    <div style={{ width: '50%'}}>
                                        <span style={{ color: '#4f62b5' }}>Полное описание: </span>
                                    </div>
                                    <div className='mobile_div_flex wrap' style={{ width: '50%'}}>
                                        {item.text}
                                    </div>
                                </div>
                                <div className='mobile_div_flex' style={{ width: 'calc(50% + 80px)', justifyContent: 'flex-end'}}>
                                    <ActionMenu actions={actions}/>
                                </div>
                            </div>
                        </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    if(window.innerWidth < 950)
        return(
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {renderBodyMobile()}
            </table>
        );
    
    return (
        <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
            {renderThead()}
            {renderBody()}
        </table>
    );

}

export default withRouter(NewsList);